import { render } from "./UserProfile.vue?vue&type=template&id=459ea20d"
import script from "./UserProfile.vue?vue&type=script&lang=js"
export * from "./UserProfile.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\PLATEFORME-AUTO-PREFEREPLUS\\paprep-spa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__